// extracted by mini-css-extract-plugin
module.exports = {"link":"newsNavMob_link__2nMUd"};